(function () {
  function getSelectedColor() {
    var sel = document.querySelector('.product__color-swatch.selected[data-option-value]');
    return sel ? sel.getAttribute('data-option-value') : null;
  }

  function applyColor(card, color) {
    var mapEl = card.querySelector('script[data-sibling-map]');
    if (!mapEl) return;
    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }
    var match = null;
    for (var i = 0; i < map.length; i++) {
      if (map[i].color && color && map[i].color.toLowerCase() === color.toLowerCase()) {
        match = map[i];
        break;
      }
    }
    if (!match) return;

    var link = card.querySelector('.product-item__image-link');
    if (link) link.href = match.url;

    var img = card.querySelector('.product-item__image--one img, .product-item__media img');
    if (img && match.image) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = match.image;
    }

    var quickAddBtn = card.querySelector('[data-quick-shop-trigger]');
    if (quickAddBtn && quickAddBtn.hasAttribute('data-product-url')) {
      quickAddBtn.setAttribute('data-product-url', match.url);
    }
  }

  function syncSection(section) {
    var color = getSelectedColor();
    if (!color) return;
    section.querySelectorAll('.product-item').forEach(function (card) {
      applyColor(card, color);
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-section-type="recommended-products"]').forEach(syncSection);
  }

  function swapImage(img, url) {
    if (!img || !url) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

function syncColorAwareImages() {
    var color = getSelectedColor(); if (!color) return; var normalizedColor = color.toLowerCase(); document.querySelectorAll('[data-color-variant-images]').forEach(function (container) { var map; try { map = JSON.parse(container.getAttribute('data-color-variant-images') || '{}'); } catch (e) { return; } var matchedKey = Object.keys(map).filter(function (key) { return key.toLowerCase() === normalizedColor; })[0]; if (!matchedKey) return; var entry = map[matchedKey]; if (!entry) return; var roleEls = container.hasAttribute('data-color-image-role') ? [container] : container.querySelectorAll('[data-color-image-role]'); roleEls.forEach(function (roleEl) { var role = roleEl.getAttribute('data-color-image-role'); var url = entry[role]; if (!url) return; swapImage(roleEl.querySelector('img.image__img') || roleEl.querySelector('img'), url); }); });
}
  function syncEverything() {
    syncAll();
    syncColorAwareImages();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product__color-swatch[data-option-value]');
    if (btn) setTimeout(syncEverything, 60);
  });

  function init() {
    setTimeout(syncEverything, 300);
    document.querySelectorAll('[data-section-type="recommended-products"] [data-recommendations]').forEach(function (el) {
      new MutationObserver(syncAll).observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
